// @ts-check
import { TextareaAutosize } from '@material-ui/core';
import styled from 'styled-components';

const TextareaAutosizeWrapper = styled(TextareaAutosize)`
  resize: none;
  font-size: 15px;
  line-height: 25px;
`;

export default function TextArea(props) {
  const handleTextChange = ({ target }) => {
    props.onChange(target.value.split('\n'));
  };

  return (
    <TextareaAutosizeWrapper
      className='border border-slate-200 rounded-sm'
      onChange={handleTextChange}
      value={props.value ? props.value.join('\n') : ''}
      data-cy={props.dataCy}
    />
  );
}
